import styled from '@emotion/styled';
import MuiModal from '@mui/material/Modal';

export const Modal = styled(MuiModal)`
  max-width: 375px;
  height: auto;
  top: 30%;
  bottom: 0;
  margin: auto;
  align-items: center;
  justify-content: center;
  @media (max-width: 580px) {
    top: auto;
    max-width: 100%;
  }
`;

export const Container = styled.div`
  max-width: 375px;
  background-color: ${({ theme, bgColor }) =>
    theme.colors[bgColor] || theme.colors.primaryMain};
  border: none;
  box-shadow: none;
  padding: 32px;
  @media (max-width: 580px) {
    max-width: 100%;
  }
`;
